import styled from "styled-components";

import { Flex } from "@olist/design-system";
import { themes } from "@olist/design-system-tokens";

export const DiscussionContainer = styled(Flex)`
  flex-direction: column;
  row-gap: ${({ theme }) => theme.olist.spacing.stack.medium};
  i {
    font-style: italic;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
  }

  ol {
    list-style-type: decimal;
    margin-left: 16px;
  }

  a {
    color: ${themes.olist.base.color.primary.base};
    text-decoration: underline;
  }
`;
